import {FormControl} from 'platform/components';
import {Grid} from 'platform/foundation';

import {useEffect} from 'react';
import {Path, UseFormReturn, useWatch} from 'react-hook-form';

import {BackgroundRemovalFormValues} from '../types/BackgroundRemovalFormValues';
import {ImageOptionItem} from './ImageOptionItem';

interface BackgroundSelectorProps {
  name: Path<BackgroundRemovalFormValues>;
  options: string[];
  control: FormControl<BackgroundRemovalFormValues>;
  formApi: UseFormReturn<BackgroundRemovalFormValues>;
  externalOnClick?: (value: string) => void;
}

export function BackgroundSelector(props: BackgroundSelectorProps) {
  const activeItem = useWatch({
    control: props.formApi.control,
    name: props.name,
  }) as (typeof props.options)[number];

  useEffect(
    function registerField() {
      props.formApi.register(props.name);
    },
    [props.formApi, props.name]
  );

  return (
    <Grid columns={4}>
      {props.options.map((style) => (
        <ImageOptionItem
          key={style}
          formApi={props.formApi}
          name={props.name}
          value={style}
          activeItem={activeItem}
          externalOnClick={props.externalOnClick}
        />
      ))}
    </Grid>
  );
}
